<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Details</h4>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <template v-if="supplier">
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Company</label>
                <md-input
                  v-model="supplier.company"
                  type="text"
                  ref="title"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Contact Name</label>
                <md-input
                  v-model="supplier.contact_name"
                  type="text"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Contact Number</label>
                <md-input v-model="supplier.tel_num" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Email Address</label>
                <md-input v-model="supplier.email" type="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="supplier.address_1" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="supplier.address_2" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>City</label>
                <md-input v-model="supplier.city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>County/State</label>
                <md-input v-model="supplier.county" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label for="country">Country</label>
                <md-select
                  v-model="supplier.country"
                  name="country"
                  id="country"
                >
                  <md-option
                    v-for="country in countries"
                    :key="country"
                    :value="country"
                  >
                    {{ country }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Postcode</label>
                <md-input v-model="supplier.postcode" type="text"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button
                class="md-raised md-success md-dense mt-4"
                @click.prevent="update"
                >{{ updateButtonText }}</md-button
              >
            </div>
          </div>
        </form>

        <supplier-user-list
          v-if="updateMode == 'UPDATE'"
          :workers="supplier.workers"
          @addWorker="addWorker"
          @removeWorker="removeWorker"
        />

        <supplier-guide-list
          v-if="updateMode == 'UPDATE'"
          :guides="supplier.guides"
          @addGuide="addGuide"
          @removeGuide="removeGuide"
        />

        <supplier-tour-list
          v-if="updateMode == 'UPDATE'"
          :tours="supplier.tours"
        />
      </template>
      <div class="md-layout" v-else>
        <div class="md-layout-item md-size-100">
          Please select a Partner
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import supplierApi from "@/services/api/supplier";
import optionsApi from "@/services/api/options";
import _filter from "lodash/filter";

import SupplierTourList from "./SupplierTourList.vue";
import SupplierUserList from "./SupplierUserList.vue";
import SupplierGuideList from "./SupplierGuideList.vue";

export default {
  props: ["supplier"],

  components: {
    SupplierTourList,
    SupplierUserList,
    SupplierGuideList
  },

  data() {
    return {
      countries: []
    };
  },

  computed: {
    updateMode: function() {
      return this.supplier.id ? "UPDATE" : "CREATE";
    },
    updateButtonText: function() {
      return this.updateMode == "UPDATE" ? "Update" : "Add";
    }
  },

  methods: {
    update() {
      let save = null;
      let message = "";

      switch (this.updateMode) {
        case "UPDATE":
          save = supplierApi.update(this.supplier);
          message = "Updated!";
          break;

        default:
          save = supplierApi.create(this.supplier);
          message = "Added!";
      }

      save.then(response => {
        this.$notify({
          timeout: 2500,
          message: message,
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });

        this.$emit("supplierUpdated", {
          supplier: response.data,
          mode: this.updateMode
        });
      });
    },

    addWorker(workerId) {
      supplierApi
        .addWorker(this.supplier.id, workerId)
        .then(resp => {
          this.supplier.workers.push(resp.data.worker);
        })
        .catch(err => {
          this.showError(err.response.data.message);
        });
    },

    showError(message) {
      this.$notify({
        timeout: 2500,
        message: message,
        icon: "cancel",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "danger"
      });
    },

    removeWorker(workerId) {
      supplierApi.removeWorker(this.supplier.id, workerId).then(resp => {
        this.supplier.workers = _filter(this.supplier.workers, function(el) {
          return el.id !== workerId;
        });
      });
    },

    addGuide(guideId) {
      supplierApi
        .addGuide(this.supplier.id, guideId)
        .then(resp => {
          this.supplier.guides.push(resp.data.guide);
        })
        .catch(err => {
          this.showError(err.response.data.message);
        });
    },

    removeGuide(guideId) {
      supplierApi.removeGuide(this.supplier.id, guideId).then(resp => {
        this.supplier.guides = _filter(this.supplier.guides, function(el) {
          return el.id !== guideId;
        });
      });
    }
  },

  created() {
    optionsApi.countries().then(response => {
      this.countries = response.data;
    });
  }
};
</script>
